module.exports = __webpack_public_path__ + "static/media/logo_red.07e31012.png";